import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const waitForGtag = () => {
  return new Promise((resolve) => {
    if (window.gtag) {
      resolve(window.gtag);
      return;
    }

    const checkGtag = setInterval(() => {
      if (window.gtag) {
        clearInterval(checkGtag);
        resolve(window.gtag);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkGtag);
      console.warn('GA Debug: Timeout esperando gtag carregar');
      resolve(null);
    }, 5000);
  });
};

export const useGoogleAnalytics = () => {
  const location = useLocation();
  const [isGAReady, setIsGAReady] = useState(false);

  useEffect(() => {
    const initGA = async () => {
      const gtag = await waitForGtag();
      setIsGAReady(!!gtag);

      if (gtag && window.gaTrackingId) {
        gtag('config', window.gaTrackingId, {
          page_path: location.pathname + location.search
        });
      }
    };

    initGA();
  }, [location]);

  const trackEvent = async (action, category, label, value) => {
    if (!isGAReady || !window.gaTrackingId) {
      console.warn('GA Debug: GA não está pronto ou não configurado');
      return;
    }

    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  };

  return { trackEvent, isGAReady };
};

export default useGoogleAnalytics; 